import * as z from "zod";

export const packageProtectionPlusCoverageRateGranularitySchema = z.enum([
  "day",
  "month",
]);
export type PackageProtectionPlusCoverageRateGranularity = z.infer<
  typeof packageProtectionPlusCoverageRateGranularitySchema
>;

export const packageProtectionPlusCoverageRateBucketSchema = z.object({
  bucket: z
    .string()
    .describe("ISO timestamp marking the start of the bucket (day or month)"),
  protectedOrders: z
    .number()
    .int()
    .describe(
      "Number of package-protected orders placed in this bucket for teams with package protection plus enabled",
    ),
  ordersWithReportedShipments: z
    .number()
    .int()
    .describe(
      "Subset of protectedOrders that have at least one shipment recorded with the insurance provider",
    ),
});

export type PackageProtectionPlusCoverageRateBucket = z.infer<
  typeof packageProtectionPlusCoverageRateBucketSchema
>;

export const getPackageProtectionPlusCoverageRate = {
  name: "getPackageProtectionPlusCoverageRate" as const,
  input: z.object({
    startDate: z
      .string()
      .describe("Inclusive ISO timestamp lower bound on shopify_created_at"),
    endDate: z
      .string()
      .describe("Exclusive ISO timestamp upper bound on shopify_created_at"),
    granularity: packageProtectionPlusCoverageRateGranularitySchema,
  }),
  output: z.object({
    buckets: z.array(packageProtectionPlusCoverageRateBucketSchema),
  }),
};
